import { useRouter } from "next/router";

const withPackPreviewGuard = () => (WrappedComponent) => {
  const Guard = (props) => {
    const { pathname } = useRouter();

    return (
      pathname !== '/packs/[id]/preview'  ? <WrappedComponent { ...props } /> : null
    )
  }
  Guard.displayName = 'withPackPreviewGuard';
  return Guard;
}

export default withPackPreviewGuard;
